import { render, staticRenderFns } from "./TPAGames.vue?vue&type=template&id=f61be0f8&scoped=true&"
import script from "./TPAGames.vue?vue&type=script&lang=js&"
export * from "./TPAGames.vue?vue&type=script&lang=js&"
import style0 from "./TPAGames.vue?vue&type=style&index=0&id=f61be0f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61be0f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VContainer,VPagination,VRow,VSelect,VTooltip})
